<mat-chip-set>
    <mat-chip class="chip" [class]="manageChipColor(promotionStatut)">
        <span class="chip-content">
            <mat-icon class="spaced-chip-icon">{{manageChipIcon(promotionStatut)}}</mat-icon>
            {{promotionStatut}}
            @if (isDropDown) {
            <mat-icon class="spaced-action-icon"> expand_more</mat-icon>
            }
        </span>

    </mat-chip>
</mat-chip-set>